var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReserveCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 2.50016H15.8334V0.833496H14.1667V2.50016H5.83342V0.833496H4.16675V2.50016H1.66675V19.1668H18.3334V2.50016ZM16.6667 17.5002H3.33341V6.66683H16.6667V17.5002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.58 11H17.43L15 18V27H18V25H30V27H33V18L30.58 11ZM18.5 22C17.67 22 17 21.33 17 20.5C17 19.67 17.67 19 18.5 19C19.33 19 20 19.67 20 20.5C20 21.33 19.33 22 18.5 22ZM29.5 22C28.67 22 28 21.33 28 20.5C28 19.67 28.67 19 29.5 19C30.33 19 31 19.67 31 20.5C31 21.33 30.33 22 29.5 22ZM17 17L18.5 12.5H29.5L31 17H17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserveCar);
export default __webpack_public_path__ + "static/media/reserve-car.f3d3921f48c99a42ffa7a1ff15aaa49c.svg";
export { ForwardRef as ReactComponent };